import { StateCreator } from "zustand";

import { LOGOUT_URL } from "@/data/auth";

import { AppState, AuthSlice, Mutators } from "./types";

export const createAuthSlice: StateCreator<
  AppState,
  Mutators,
  [],
  AuthSlice
> = (set, get) => ({
  authToken: null,
  session: null,
  logIn: (authToken) => {
    set({ authToken });
  },
  logOut: () => {
    const { session } = get();

    set({ authToken: null });

    window.localStorage.removeItem("token");
    window.location.href = LOGOUT_URL + session?.session_id;
  },
  setSession: (session) => {
    set({ session });
  },
});
